/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import { useSprings, useSpringRef, animated } from '@react-spring/web';

// import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/users-visualisation.module.scss';
import { useWindowSize } from '../../contexts/SiteContext';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const UsersVisualisation = ({ className }) => {
    const delay = 2000;
    const [items, setItems] = useState([]);
    const { width: windowWidth, height: windowHeight } = useWindowSize();
    const timer = useRef(null);

    useEffect(() => {
        timer.current = setInterval(() => {
            const newItems = [...Array(10).keys()].map(() => ({
                x: Math.floor(Math.random() * windowWidth),
                y: Math.floor(Math.random() * windowHeight),
            }));
            setItems((old) => [...old, ...newItems]);
        }, delay);

        return () => {
            if (timer.current !== null) {
                clearInterval(timer.current);
                timer.current = null;
            }
        };
    }, [delay]);

    // const boxApi = useSpringRef();
    // const [boxSprings] = useSprings(items.length, (i) => ({
    //     ref: boxApi,
    //     from: {
    //         scale: 0,
    //     },
    //     to: {
    //         scale: 1,
    //     },
    //     delay: i * 200,
    //     config: {
    //         mass: 2,
    //         tension: 220,
    //     },
    // }));

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {items.map(({ x = 0, y = 0 }, i) => (
                <div
                    key={`${i + 1}-${x}-${y}`}
                    className={styles.dot}
                    style={{ left: x, top: y }}
                />
            ))}
            {/* <svg
                width={`${windowWidth}px`}
                height={`${windowHeight}px`}
                viewBox={`0 0 ${windowWidth} ${windowHeight}`}
            >
                {boxSprings.map(({ scale }, index) => (
                    <animated.rect
                        key={index}
                        width="2px"
                        height="2px"
                        x={`${items[index].x}px`}
                        y={`${items[index].y}px`}
                        fill="#FFF"
                        style={{
                            // transformOrigin: `center`,
                            // transform: `translate(${items[index].x}px, ${items[index].y}px)`,
                            scale: 1,
                        }}
                    />
                ))}
            </svg> */}
        </div>
    );
};

UsersVisualisation.propTypes = propTypes;
UsersVisualisation.defaultProps = defaultProps;

export default UsersVisualisation;
